var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-3" }, [
    _c(
      "table",
      {
        class: [_vm.isReadOnly ? "disabled-background" : "", "table tablerow"]
      },
      [
        _c(
          "caption",
          [
            _c("plain-text-control", {
              attrs: { title: _vm.title, required: true }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("thead", [
          _c("tr", [
            _c(
              "th",
              {
                staticClass: "w-15",
                attrs: {
                  id: _vm.title + "_" + _vm.tableIndex + "_operationtype"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t(
                          "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.OperationType"
                        )
                      ) +
                      "\n          "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-20",
                attrs: { id: _vm.title + "_" + _vm.tableIndex + "_description" }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.Description"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.hasTargets
              ? _c(
                  "th",
                  {
                    staticClass: "w-12-5 right",
                    attrs: {
                      id: _vm.title + "_" + _vm.tableIndex + "_targets",
                      colspan: "2"
                    }
                  },
                  [
                    _c(
                      "span",
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.Targets"
                              )
                            ) +
                            "\n            "
                        ),
                        _c("tooltip-icon", {
                          attrs: {
                            content: _vm.$t(
                              "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.Targets_Instructions"
                            )
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-10 right",
                attrs: {
                  id: _vm.title + "_" + _vm.tableIndex + "_operationcount"
                }
              },
              [
                _c(
                  "span",
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.OperationCount"
                          )
                        ) +
                        "\n            "
                    ),
                    _c("tooltip-icon", {
                      attrs: {
                        content: _vm.$t(
                          "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.OperationCount_Instructions"
                        )
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-15",
                attrs: {
                  id: _vm.title + "_" + _vm.tableIndex + "_collectionmethod"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.CollectionMethod"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-12-5 right",
                attrs: {
                  id: _vm.title + "_" + _vm.tableIndex + "_realizedcount",
                  colspan: "2"
                }
              },
              [
                _c(
                  "span",
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.RealizedCount"
                          )
                        ) +
                        "\n            "
                    ),
                    _c("tooltip-icon", {
                      attrs: {
                        content: _vm.$t(
                          "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.RealizedCount_Instructions"
                        )
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-10 right",
                attrs: {
                  id: _vm.title + "_" + _vm.tableIndex + "_encountercount"
                }
              },
              [
                _c(
                  "span",
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.EncounterCount"
                          )
                        ) +
                        "\n            "
                    ),
                    _c("tooltip-icon", {
                      attrs: {
                        content: _vm.$t(
                          "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.EncounterCount_Instructions"
                        )
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-5 centered",
                attrs: { id: _vm.title + "_" + _vm.tableIndex + "_actions" }
              },
              [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.$t("Sr_Actions")))
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.items, function(item, index) {
            return _c(
              "tr",
              { key: index, staticClass: "paddingless" },
              [
                _c("single-select-table-cell", {
                  attrs: {
                    classes: ["w-15 input-cell"],
                    options: _vm.optionsArray("OperationTypeOptions", true),
                    required: true,
                    dropdownId: "operationtype_" + _vm.tableIndex + "_" + index,
                    title:
                      "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.OperationType",
                    srLabel: true
                  },
                  model: {
                    value: item.operationType,
                    callback: function($$v) {
                      _vm.$set(item, "operationType", $$v)
                    },
                    expression: "item.operationType"
                  }
                }),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "w-20 input-cell" },
                  [
                    _c("text-area-control", {
                      attrs: {
                        id: "description_" + _vm.tableIndex + "_" + index,
                        maxLength: 100,
                        required: true,
                        rows: 1,
                        placeholderKey: "Placeholder.TextArea",
                        labelledBy:
                          _vm.title + "_" + _vm.tableIndex + "_description",
                        showTooltip: true
                      },
                      model: {
                        value: item.description,
                        callback: function($$v) {
                          _vm.$set(item, "description", $$v)
                        },
                        expression: "item.description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasTargets
                  ? _c(
                      "td",
                      {
                        staticClass:
                          "w-5 spanned-left applies-to-next-target-cell"
                      },
                      [
                        !_vm.isReadOnly
                          ? _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.top.center",
                                    value: {
                                      content: _vm.$t(
                                        "ContinuousReport.Button.SelectTarget"
                                      )
                                    },
                                    expression:
                                      "{ content: $t('ContinuousReport.Button.SelectTarget') }",
                                    modifiers: { top: true, center: true }
                                  }
                                ],
                                class: ["btn btn-contrast btn-link-custom"],
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.showModal(index)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-plus-square fa-lg centered"
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "ContinuousReport.Button.SelectTarget"
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasTargets
                  ? _c("ValidationProvider", {
                      attrs: {
                        rules: { required: true },
                        mode: "aggressive",
                        slim: ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              var failedRules = ref.failedRules
                              return [
                                _c(
                                  "td",
                                  {
                                    class: [
                                      _vm.getValidationErrorClasses(
                                        failedRules
                                      ),
                                      "w-7-5 spanned-right next-target-cell right"
                                    ]
                                  },
                                  [
                                    _c("check-box-dialog-row", {
                                      attrs: {
                                        id:
                                          "targets_" +
                                          _vm.tableIndex +
                                          "_" +
                                          index,
                                        title:
                                          "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.Targets",
                                        options: _vm.targets,
                                        displayOptionNames: false,
                                        buttonTooltip:
                                          "ContinuousReport.Button.SelectTarget",
                                        inTable: true
                                      },
                                      model: {
                                        value: item.targets,
                                        callback: function($$v) {
                                          _vm.$set(item, "targets", $$v)
                                        },
                                        expression: "item.targets"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("numeric-input-table-cell", {
                  attrs: {
                    classes: ["w-10 input-cell"],
                    placeholderKey: _vm.numberInputPlaceholderKey,
                    required: false,
                    labelledBy:
                      _vm.title + "_" + _vm.tableIndex + "_operationcount"
                  },
                  model: {
                    value: item.operationCount,
                    callback: function($$v) {
                      _vm.$set(item, "operationCount", $$v)
                    },
                    expression: "item.operationCount"
                  }
                }),
                _vm._v(" "),
                _c("single-select-table-cell", {
                  attrs: {
                    classes: ["w-15 input-cell"],
                    options: _vm.optionsArray("CollectionMethodOptions", true),
                    required: true,
                    dropdownId:
                      "collectionmethod_" + _vm.tableIndex + "_" + index,
                    title:
                      "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.CollectionMethod",
                    srLabel: true
                  },
                  on: {
                    input: function($event) {
                      return _vm.setDistributionVisibility(item)
                    }
                  },
                  model: {
                    value: item.collectionMethod,
                    callback: function($$v) {
                      _vm.$set(item, "collectionMethod", $$v)
                    },
                    expression: "item.collectionMethod"
                  }
                }),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "w-5 spanned-left applies-to-next-distribution-cell"
                  },
                  [
                    !item.hasAgeGenderDistribution &&
                    (item.collectionMethod == _vm.CollectionMethod.Collected ||
                      item.collectionMethod == _vm.CollectionMethod.Sampling) &&
                    !_vm.isReadOnly
                      ? _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top.center",
                                value: {
                                  content: _vm.$t(
                                    "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.AddDistribution"
                                  )
                                },
                                expression:
                                  "{ content: $t('ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.AddDistribution') }",
                                modifiers: { top: true, center: true }
                              }
                            ],
                            class: ["btn btn-contrast btn-link-custom"],
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.setItemHasDistribution(item, true)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-plus-square fa-lg centered"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.AddDistribution"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      : _c("span", { staticClass: "sr-only" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.DistributionAdded"
                              )
                            )
                          )
                        ])
                  ]
                ),
                _vm._v(" "),
                _c("ValidationProvider", {
                  attrs: {
                    rules: {
                      required: false,
                      min_value: 0,
                      max_value: 1000000000
                    },
                    mode: "aggressive",
                    slim: ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var failedRules = ref.failedRules
                          return [
                            _c(
                              "td",
                              {
                                class: [
                                  _vm.getValidationErrorClasses(failedRules),
                                  "w-7-5 input-cell spanned-right next-distribution-cell"
                                ]
                              },
                              [
                                _c("numeric-input-control", {
                                  staticClass: "float-left",
                                  attrs: {
                                    required: false,
                                    placeholderKey:
                                      _vm.numberInputPlaceholderKey,
                                    labelledBy:
                                      _vm.title +
                                      "_" +
                                      _vm.tableIndex +
                                      "_realizedcount"
                                  },
                                  model: {
                                    value: item.realizedCount,
                                    callback: function($$v) {
                                      _vm.$set(item, "realizedCount", $$v)
                                    },
                                    expression: "item.realizedCount"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("numeric-input-table-cell", {
                  attrs: {
                    classes: ["w-10 input-cell"],
                    required: false,
                    placeholderKey: _vm.numberInputPlaceholderKey,
                    labelledBy:
                      _vm.title + "_" + _vm.tableIndex + "_encountercount"
                  },
                  model: {
                    value: item.encounterCount,
                    callback: function($$v) {
                      _vm.$set(item, "encounterCount", $$v)
                    },
                    expression: "item.encounterCount"
                  }
                }),
                _vm._v(" "),
                _c("td", { staticClass: "w-5 centered" }, [
                  _c("span", { staticClass: "p-0" }, [
                    _vm.showDeleteBtn && !_vm.isReadOnly
                      ? _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top.center",
                                value: { content: _vm.$t("Btn_DeleteRow") },
                                expression: "{ content: $t('Btn_DeleteRow') }",
                                modifiers: { top: true, center: true }
                              }
                            ],
                            staticClass: "btn btn-link btn-contrast",
                            attrs: {
                              type: "button",
                              "aria-label":
                                _vm.$t("Btn_DeleteRow") +
                                (index + 2) +
                                " -. " +
                                _vm.$t("Accessibility.ConfirmDeleteRow")
                            },
                            on: {
                              click: function($event) {
                                return _vm.deleteRow(index)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-trash-alt fa-lg centered"
                            })
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ],
              1
            )
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    !_vm.isReadOnly
      ? _c("div", { staticClass: "mt-3 mb-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.addRow()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t(_vm.buttonTitle)))]
          )
        ])
      : _c("div", { staticClass: "mt-5" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }